import {ChangeDetectionStrategy, Component, inject, Input, OnInit, signal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {OphQuillEditorModule} from '../../shared/design/oph-quill-editor/oph-quill-editor.module';
import {OphDrawerService} from './../../shared/design/oph-drawer/oph-drawer.service';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';
import {OphIconModule} from './../../shared/design/oph-icon/oph-icon.module';
import {GetWikiItemAction} from '../../core/store/wiki/wiki.action';
import {selectWikiItem} from '../../core/store/wiki/wiki.selector';
import {WikiItem} from '../models/wiki.model';
import {WIKI_ITEM_QUILL_STYLES} from '../utils/wiki-item-quill-config';

@Component({
  selector: 'wiki-view-article',
  standalone: true,
  imports: [OphQuillEditorModule, CommonModule, OphLoadingModule, MatButtonModule, OphIconModule],
  templateUrl: './wiki-view-article.component.html',
  styleUrl: './wiki-view-article.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiViewArticleComponent implements OnInit {
  @Input() itemId: string;
  @Input() slug: string = '...';
  private router = inject(Router);
  private store$ = inject(Store);
  private ophDrawerService = inject(OphDrawerService);
  public wikiItem$: Observable<WikiItem> = this.store$.select(selectWikiItem);
  public quillStyles = {
    ...WIKI_ITEM_QUILL_STYLES,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderTop: '1px solid #E5E3DC',
  };

  isLoading = signal<boolean>(true);
  isPostFullView = signal<boolean>(false);

  ngOnInit(): void {
    this.getWikiItem();
    this.setIsPostFullView();
  }

  setIsPostFullView(): void {
    this.isPostFullView.set(this.router.url.includes('/wiki/view/'));
  }

  getWikiItem(): void {
    this.store$.dispatch(
      new GetWikiItemAction({
        itemId: this.itemId,
        onSuccess: () => {
          this.isLoading.set(false);
        },
        onFailure: error => {
          this.isLoading.set(true);
          this.router.navigate(['/current-sked']);
        },
      })
    );
  }

  onCancel(): void {
    this.ophDrawerService.closeDrawer();
  }
}
